module.exports = __webpack_public_path__ + "static/media/Group_1597880790@2x.34cc9c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1597880790@2x.png
// module id = 1747
// module chunks = 0